/**
 * Shared helpers for Business Config forms (Angular parity).
 */

/** Strip HTML tags + `&nbsp;` and trim — used to detect empty rich-text (CKEditor). */
export function stripRichText(html: string): string {
  return (html || '')
    .replace(/<[^>]*>/g, '')
    .replace(/&nbsp;/g, ' ')
    .trim()
}

/** True when a rich-text value has no real content (e.g. `<p></p>`, `<p>&nbsp;</p>`). */
export function isRichTextEmpty(html: string): boolean {
  return stripRichText(html).length === 0
}

/**
 * Lightweight HTML sanitizer for rendering stored rich-text (Angular `[innerHTML]`
 * auto-sanitizes). Strips scripts/styles, inline event handlers, and `javascript:`
 * URLs — same approach as the resident notes components.
 */
export function sanitizeHtml(html: string): string {
  return (html || '')
    .replace(/<\/?(script|style)[^>]*>/gi, '')
    .replace(/ on[a-z]+="[^"]*"/gi, '')
    .replace(/ on[a-z]+='[^']*'/gi, '')
    .replace(/javascript:/gi, '')
}

/**
 * Angular `normalizeHashtagNote`: trim; if the note starts with `#`, strip whitespace
 * immediately following the `#` (e.g. `"#   Foo"` → `"#Foo"`).
 */
export function normalizeHashtagNote(text: string): string {
  const trimmed = (text || '').trim()
  if (trimmed.startsWith('#')) {
    return `#${trimmed.slice(1).replace(/^\s+/, '')}`
  }
  return trimmed
}
